// styles and images
import { useEffect, useState } from "react";
import { projectStore } from "../../store/Store";
import "./Project.css";

export default function PoTotals() {
  // global
  const projectTotals = projectStore((data) => data.projectTotals);

  // local
  const [freightPOs, setFreightPOs] = useState([]);
  const [sandPOs, setSandPOs] = useState([]);

  const [freightPOTotals, setFreightPOTotals] = useState({
    invoiced_weight: 0,
    invoiced_cost: 0,
    received_weight: 0,
    received_cost: 0,
    rni_weight: 0,
    rni_amount: 0,
  });
  const [sandPOTotals, setSandPOTotals] = useState({
    invoiced_weight: 0,
    invoiced_cost: 0,
    received_weight: 0,
    received_cost: 0,
    rni_weight: 0,
    rni_amount: 0,
  });

  useEffect(() => {
    const tots = [];
    const sTots = []
    const fTotals = {
      invoiced_weight: 0,
      invoiced_cost: 0,
      received_weight: 0,
      received_cost: 0,
      rni_weight: 0,
      rni_amount: 0,
    };
    const sTotals = {
      invoiced_weight: 0,
      invoiced_cost: 0,
      received_weight: 0,
      received_cost: 0,
      rni_weight: 0,
      rni_amount: 0,
    };
    if (projectTotals && projectTotals.project_po_totals) {
      projectTotals.project_po_totals.forEach((t) => {
        if (t.sand_po === "") {
          let tot = tots.filter((x) => x.vendor === t.vendor);
          if (tot.length === 0) {
            let newTot = {
              vendor: t.vendor,
              rate: [t.rate],
              weight_received: [t.weight_received],
              weight_invoiced: [t.weight_invoiced],
              rni_weight: [t.weight_received - t.weight_invoiced],
              received_amount: [t.received_amount],
              invoice_amount: [t.invoice_amount],
              rni_amount: [t.received_amount - t.invoice_amount],
              total_invoiced_amount: t.invoice_amount,
              total_received_amount: t.received_amount,
              total_rni_amount: t.received_amount - t.invoice_amount,
              total_received_weight: t.weight_received,
              total_invoiced_weight: t.weight_invoiced,
              total_rni_weight: t.weight_received - t.weight_invoiced,
            };
            tots.push(newTot);
            fTotals.invoiced_weight =
              fTotals.invoiced_weight + t.weight_invoiced;
            fTotals.received_weight =
              fTotals.received_weight + t.weight_received;
            fTotals.invoiced_cost = fTotals.invoiced_cost + t.invoice_amount;
            fTotals.received_cost = fTotals.received_cost + t.received_amount;
            fTotals.rni_weight =
              fTotals.rni_weight + t.weight_received - t.weight_invoiced;
            fTotals.rni_amount =
              fTotals.rni_amount + t.received_amount - t.invoice_amount;
          } else {
            tot[0].rate.push(t.rate);
            tot[0].weight_received.push(t.weight_received);
            tot[0].weight_invoiced.push(t.weight_invoiced);
            tot[0].received_amount.push(t.received_amount);
            tot[0].invoice_amount.push(t.invoice_amount);
            tot[0].rni_weight.push(t.weight_received - t.weight_invoiced);
            tot[0].rni_amount.push(t.received_amount - t.invoice_amount);
            tot[0].total_invoiced_amount =
              tot[0].total_invoiced_amount + t.invoice_amount;
            tot[0].total_received_amount =
              tot[0].total_received_amount + t.received_amount;
            tot[0].total_rni_amount =
              tot[0].total_rni_amount + t.received_amount - t.invoice_amount;
            tot[0].total_invoiced_weight =
              tot[0].total_invoiced_weight + t.weight_invoiced;
            tot[0].total_received_weight =
              tot[0].total_received_weight + t.weight_received;
            tot[0].total_rni_weight =
              tot[0].total_rni_weight + t.weight_received - t.weight_invoiced;
            fTotals.invoiced_weight =
              fTotals.invoiced_weight + t.weight_invoiced;
            fTotals.received_weight =
              fTotals.received_weight + t.weight_received;
            fTotals.invoiced_cost = fTotals.invoiced_cost + t.invoice_amount;
            fTotals.received_cost = fTotals.received_cost + t.received_amount;
            fTotals.rni_weight =
              fTotals.rni_weight + t.weight_received - t.weight_invoiced;
            fTotals.rni_amount =
              fTotals.rni_amount + t.received_amount - t.invoice_amount;
          }
        } else {
          let tot = sTots.filter((x) => x.vendor === t.vendor);
          if (tot.length === 0) {
            let newTot = {
              vendor: t.vendor,
              rate: [t.rate],
              sand_po: [t.sand_po],
              weight_received: [t.weight_received],
              weight_invoiced: [t.weight_invoiced],
              rni_weight: [t.weight_received - t.weight_invoiced],
              received_amount: [t.received_amount],
              invoice_amount: [t.invoice_amount],
              rni_amount: [t.received_amount - t.invoice_amount],
              total_invoiced_amount: t.invoice_amount,
              total_received_amount: t.received_amount,
              total_rni_amount: t.received_amount - t.invoice_amount,
              total_received_weight: t.weight_received,
              total_invoiced_weight: t.weight_invoiced,
              total_rni_weight: t.weight_received - t.weight_invoiced,
            };
            sTots.push(newTot);
            sTotals.invoiced_weight =
              sTotals.invoiced_weight + t.weight_invoiced;
            sTotals.received_weight =
              sTotals.received_weight + t.weight_received;
            sTotals.invoiced_cost = sTotals.invoiced_cost + t.invoice_amount;
            sTotals.received_cost = sTotals.received_cost + t.received_amount;
            sTotals.rni_weight =
              sTotals.rni_weight + t.weight_received - t.weight_invoiced;
            sTotals.rni_amount =
              sTotals.rni_amount + t.received_amount - t.invoice_amount;
          } else {
            tot[0].rate.push(t.rate);
            tot[0].sand_po.push(t.sand_po);
            tot[0].weight_received.push(t.weight_received);
            tot[0].weight_invoiced.push(t.weight_invoiced);
            tot[0].received_amount.push(t.received_amount);
            tot[0].invoice_amount.push(t.invoice_amount);
            tot[0].rni_weight.push(t.weight_received - t.weight_invoiced);
            tot[0].rni_amount.push(t.received_amount - t.invoice_amount);
            tot[0].total_invoiced_amount =
              tot[0].total_invoiced_amount + t.invoice_amount;
            tot[0].total_received_amount =
              tot[0].total_received_amount + t.received_amount;
            tot[0].total_rni_amount =
              tot[0].total_rni_amount + t.received_amount - t.invoice_amount;
            tot[0].total_invoiced_weight =
              tot[0].total_invoiced_weight + t.weight_invoiced;
            tot[0].total_received_weight =
              tot[0].total_received_weight + t.weight_received;
            tot[0].total_rni_weight =
              tot[0].total_rni_weight + t.weight_received - t.weight_invoiced;
            sTotals.invoiced_weight =
              sTotals.invoiced_weight + t.weight_invoiced;
            sTotals.received_weight =
              sTotals.received_weight + t.weight_received;
            sTotals.invoiced_cost = sTotals.invoiced_cost + t.invoice_amount;
            sTotals.received_cost = sTotals.received_cost + t.received_amount;
            sTotals.rni_weight =
              sTotals.rni_weight + t.weight_received - t.weight_invoiced;
            sTotals.rni_amount =
              sTotals.rni_amount + t.received_amount - t.invoice_amount;
          }
        }
      });
      setFreightPOTotals(fTotals);
      setSandPOTotals(sTotals);
    }
    tots.forEach((t) => {
      t.rate.push("");
      t.weight_received.push(t.total_received_weight);
      t.weight_invoiced.push(t.total_invoiced_weight);
      t.invoice_amount.push(t.total_invoiced_amount);
      t.received_amount.push(t.total_received_amount);
      t.rni_weight.push(t.total_rni_weight);
      t.rni_amount.push(t.total_rni_amount);
    });
    setFreightPOs(tots);
    sTots.forEach((t) => {
      t.rate.push("");
      t.sand_po.push("")
      t.weight_received.push(t.total_received_weight);
      t.weight_invoiced.push(t.total_invoiced_weight);
      t.invoice_amount.push(t.total_invoiced_amount);
      t.received_amount.push(t.total_received_amount);
      t.rni_weight.push(t.total_rni_weight);
      t.rni_amount.push(t.total_rni_amount);
    })
    setSandPOs(sTots)
  }, [projectTotals, setFreightPOs]);

  return (
    projectTotals &&
    projectTotals.project_po_totals &&
    freightPOs && (
      <div className="col">
        <div className="p-2 border text-center project-card">
          {projectTotals && (
            <div className="project-card-list">
              <h5>Freight PO Totals</h5>
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Vendor</th>
                    <th>Rate</th>
                    <th>Total Invoiced (tons)</th>
                    <th>Total Received (tons)</th>
                    <th>RNI (tons)</th>
                    <th>Total Invoiced $</th>
                    <th>Total Received $</th>
                    <th>RNI $</th>
                  </tr>
                </thead>
                <tbody>
                  {freightPOs.map(
                    (t) =>
                      t.rate.map((_, j) => (
                        <tr key={j}>
                          {j === 0 ? (
                            <td>{t.vendor}</td>
                          ) : j === t.rate.length - 1 ? (
                            <td className="td-totals">{`${t.vendor} Totals`}</td>
                          ) : (
                            <td></td>
                          )}
                          <td>{t.rate[j]}</td>
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.weight_invoiced[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>
                              {t.weight_invoiced[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          )}
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.weight_received[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>
                              {t.weight_received[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          )}
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.rni_weight[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>
                              {t.rni_weight[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          )}
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.invoice_amount[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>
                              {t.invoice_amount[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          )}
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.received_amount[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>
                              {t.received_amount[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          )}
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.rni_amount[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>
                              {t.rni_amount[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          )}
                        </tr>
                      )),
                  )}
                  <tr key="freight_totals">
                    <td className="td-totals-xl">Freight Totals</td>
                    <td></td>
                    <td className="td-totals-xl">
                      {freightPOTotals.invoiced_weight.toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="td-totals-xl">
                      {freightPOTotals.received_weight.toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="td-totals-xl">
                      {freightPOTotals.rni_weight.toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="td-totals-xl">
                      {freightPOTotals.invoiced_cost.toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="td-totals-xl">
                      {freightPOTotals.received_cost.toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="td-totals-xl">
                      {freightPOTotals.rni_amount.toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          {projectTotals && sandPOs.length > 0 && (
            <div className="project-card-list">
              <h5>Sand PO Totals</h5>
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Vendor</th>
                    <th>PO #</th>
                    <th>Rate</th>
                    <th>Total Invoiced (tons)</th>
                    <th>Total Received (tons)</th>
                    <th>RNI (tons)</th>
                    <th>Total Invoiced $</th>
                    <th>Total Received $</th>
                    <th>RNI $</th>
                  </tr>
                </thead>
                <tbody>
                  {sandPOs.map(
                    (t) =>
                      t.rate.map((_, j) => (
                        <tr key={j}>
                          {j === 0 ? (
                            <td>{t.vendor}</td>
                          ) : j === t.rate.length - 1 ? (
                            <td className="td-totals">{`${t.vendor} Totals`}</td>
                          ) : (
                            <td></td>
                          )}
                          <td>{t.sand_po[j]}</td>
                          <td>{t.rate[j]}</td>
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.weight_invoiced[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>
                              {t.weight_invoiced[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          )}
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.weight_received[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>
                              {t.weight_received[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          )}
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.rni_weight[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>
                              {t.rni_weight[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          )}
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.invoice_amount[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>
                              {t.invoice_amount[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          )}
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.received_amount[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>
                              {t.received_amount[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          )}
                          {j === t.rate.length - 1 ? (
                            <td className="td-totals">
                              {t.rni_amount[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          ) : (
                            <td>
                              {t.rni_amount[j].toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          )}
                        </tr>
                      )),
                  )}
                  <tr key="sand_totals">
                    <td className="td-totals-xl">Sand Totals</td>
                    <td></td>
                    <td></td>
                    <td className="td-totals-xl">
                      {sandPOTotals.invoiced_weight.toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="td-totals-xl">
                      {sandPOTotals.received_weight.toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="td-totals-xl">
                      {sandPOTotals.rni_weight.toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="td-totals-xl">
                      {sandPOTotals.invoiced_cost.toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="td-totals-xl">
                      {sandPOTotals.received_cost.toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="td-totals-xl">
                      {sandPOTotals.rni_amount.toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    )
  );
}
